/**
 * 指定の DOM 配下（もしくはページ全体）に対し、youtube 埋め込み iframe に対し、ラッパー DOM を自動で差し込む
 * @param el 探索対象の HTMLElement
 */
export function addAutoWrapperOnYoutubeIframe(el?: HTMLElement): void {
  const target = el || document

  if (!target) return

  // same class name as 'app/frontend/styles/object/figure/_partials/_youtube.sass'
  const CLASS_NAME = {
    BLOCK: 'o-figure__youtube',
    ELEMENT: 'o-figure__youtube--item',
  }

  const iframes = target.querySelectorAll('iframe[src^="https://www.youtube.com"]')

  if (!iframes.length) return

  iframes.forEach(v => {
    const wrapper = document.createElement('div')
    wrapper.className = CLASS_NAME.BLOCK

    v.classList.add(CLASS_NAME.ELEMENT)
    v.before(wrapper)
    wrapper.append(v)
  })
}
